import React, { useState, useEffect } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { FaCalendarAlt } from "react-icons/fa";

const MyCalendar = () => {
  const [date, setDate] = useState(new Date());
  const [events, setEvents] = useState([]);
  const [newEventTitle, setNewEventTitle] = useState("");
  const [editEventIndex, setEditEventIndex] = useState(-1);
  const [nextId, setNextId] = useState(4);

  // Mock initial events
  const mockEvents = [
    {
      id: 1,
      date: new Date(2023, 5, 15),
      title: "Parent-Teacher Meeting",
    },
    {
      id: 2,
      date: new Date(2023, 5, 20),
      title: "School Picnic",
    },
    {
      id: 3,
      date: new Date(2023, 5, 25),
      title: "Annual Sports Day",
    },
  ];

  useEffect(() => {
    // Simulate loading events
    setEvents(mockEvents);
  }, []);

  const addEventToDate = () => {
    if (!newEventTitle.trim()) {
      alert("Please enter an event title.");
      return;
    }

    const eventDate = new Date(date);
    eventDate.setHours(0, 0, 0, 0);

    const existingEventIndex = events.findIndex(
      (event) => event.date.getTime() === eventDate.getTime()
    );

    if (existingEventIndex !== -1) {
      const updatedEvents = [...events];
      updatedEvents[existingEventIndex] = {
        ...updatedEvents[existingEventIndex],
        title: newEventTitle,
      };
      setEvents(updatedEvents);
    } else {
      const newEvent = {
        id: nextId,
        date: eventDate,
        title: newEventTitle,
      };
      setEvents([...events, newEvent]);
      setNextId(nextId + 1);
    }

    setNewEventTitle("");
    setEditEventIndex(-1);
  };

  const updateEvent = (index) => {
    if (!newEventTitle.trim()) {
      alert("Please enter an event title.");
      return;
    }

    const updatedEvents = [...events];
    updatedEvents[index] = {
      ...updatedEvents[index],
      title: newEventTitle,
    };
    setEvents(updatedEvents);
    setNewEventTitle("");
    setEditEventIndex(-1);
  };

  const removeEvent = (index) => {
    const updatedEvents = [...events];
    updatedEvents.splice(index, 1);
    setEvents(updatedEvents);
  };

  const onChange = (newDate) => {
    setDate(newDate);
    setEditEventIndex(-1);
  };

  const hasEvent = (checkDate) => {
    return events.some(
      (event) => event.date.toDateString() === checkDate.toDateString()
    );
  };

  return (
    <div className="calendar-page">
      <div className="calendar-row">
        <div className="choose-date box">
          <Calendar
            onChange={onChange}
            value={date}
            tileContent={({ date, view }) => {
              if (view === "month" && hasEvent(date)) {
                const event = events.find(
                  (ev) => ev.date.toDateString() === date.toDateString()
                );
                return <p>{event.title}</p>;
              }
            }}
          />
          <div className="add-event">
            <h3 className="main-heading">Add/Edit Event</h3>
            <input
              type="text"
              className="form-control"
              placeholder="Event Title"
              value={newEventTitle}
              onChange={(e) => setNewEventTitle(e.target.value)}
            />
            <button
              className="badge bg-success"
              onClick={
                editEventIndex !== -1
                  ? () => updateEvent(editEventIndex)
                  : addEventToDate
              }
            >
              {editEventIndex !== -1 ? "Update Event" : "Add Event to Date"}
            </button>
          </div>
        </div>
        <div className="event-list box">
          <h3 className="main-heading">List Of Events</h3>
          {events.length > 0 ? (
            <ul>
              {events
                .sort((a, b) => a.date - b.date)
                .map((event, index) => (
                  <li key={event.id} className="event-item">
                    <span className="event-date">
                      {event.date.toLocaleDateString()}
                    </span>
                    {editEventIndex === index ? (
                      <>
                        <input
                          type="text"
                          className="form-control"
                          value={newEventTitle}
                          onChange={(e) => setNewEventTitle(e.target.value)}
                        />
                        <button
                          className="badge bg-success"
                          onClick={() => updateEvent(index)}
                        >
                          Save
                        </button>
                      </>
                    ) : (
                      <>
                        {event.title}
                        <div className="event-buttons">
                          <button
                            className="badge bg-success"
                            onClick={() => {
                              setEditEventIndex(index);
                              setNewEventTitle(event.title);
                            }}
                          >
                            Edit
                          </button>
                          <button
                            className="badge bg-danger"
                            onClick={() => removeEvent(index)}
                          >
                            Remove
                          </button>
                        </div>
                      </>
                    )}
                  </li>
                ))}
            </ul>
          ) : (
            <div className="empty-state">
              <div className="empty-icon">
                <FaCalendarAlt />
              </div>
              <div className="empty-text">No Events Added</div>
              <div className="empty-subtext">
                Select a date and add events to start planning your schedule
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MyCalendar;
